import { Card } from "@/components/ui/card";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";

export const ChurnRiskAlerts = () => {
  return (
    <Card className="p-6 space-y-4">
      <h3 className="text-lg font-semibold">Churn Risk Alerts</h3>
      <Alert variant="destructive">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle>High Risk Clients</AlertTitle>
        <AlertDescription>
          Churn risk alerts will appear here when clients show signs of potential churn.
        </AlertDescription>
      </Alert>
    </Card>
  );
};